import { render, staticRenderFns } from "./simple-attributes.vue?vue&type=template&id=8b741892"
import script from "./simple-attributes.vue?vue&type=script&lang=js"
export * from "./simple-attributes.vue?vue&type=script&lang=js"
import style0 from "./simple-attributes.vue?vue&type=style&index=0&id=8b741892&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports